export default (
    document.location.host.indexOf('localhost')!==-1?
        '//api.loco.localhost:8083'
    :(
    document.location.host.indexOf('stg')!==-1?
        process.env.VUE_APP_LOCO_API.replace('//','//stg.'):
        process.env.VUE_APP_LOCO_API
    )
)
